import { useEffect } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { RoomEvent } from 'livekit-client';
import { playMeetingSound } from './meetingSounds';

const LiveKitMeetingSounds = () => {
  const room = useRoomContext();

  useEffect(() => {
    const handleParticipantConnected = () => playMeetingSound('join');
    const handleParticipantDisconnected = () => playMeetingSound('leave');

    room.on(RoomEvent.ParticipantConnected, handleParticipantConnected);
    room.on(RoomEvent.ParticipantDisconnected, handleParticipantDisconnected);

    return () => {
      room.off(RoomEvent.ParticipantConnected, handleParticipantConnected);
      room.off(RoomEvent.ParticipantDisconnected, handleParticipantDisconnected);
    };
  }, [room]);

  return null;
};

export default LiveKitMeetingSounds;
